import { createContext, useContext } from "react";

export const BUSINESS_TYPE_LABELS = {
  BARBERSHOP: "Barbearia",
  BEAUTY_SALON: "Salão de beleza",
  AESTHETICS: "Estética",
  NAILS: "Unhas",
  BROWS_LASHES: "Sobrancelhas e cílios",
  SPA_MASSAGE: "Spa e massagem",
  OTHER: "Outro",
};

// Only operational labels pass through this presentation layer. Never apply it
// to API values, names supplied by users, commercial copy or persisted data.
const OPERATIONAL_LABELS = {
  "Painel da Barbearia": "Painel do Estabelecimento",
  "Barbeiro": "Profissional",
  "Barbeiros": "Profissionais",
  "barbeiro": "profissional",
  "barbeiros": "profissionais",
  "Cancelado pelo barbeiro": "Cancelado pelo profissional",
};

export function getTerminology(businessType) {
  const type = Object.prototype.hasOwnProperty.call(BUSINESS_TYPE_LABELS, businessType)
    ? businessType : "OTHER";
  return {
    businessType: type,
    businessLabel: BUSINESS_TYPE_LABELS[type],
    // All segments use neutral operational terminology, including BARBERSHOP.
    label: (value) => Object.prototype.hasOwnProperty.call(OPERATIONAL_LABELS, value)
      ? OPERATIONAL_LABELS[value] : value,
  };
}

export const TerminologyContext = createContext(getTerminology());
export const useTerminology = () => useContext(TerminologyContext);
